"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevengeEffectHandler = exports.RevengeEffectArgs = void 0;
const CustomScript_1 = require("../../event-handlers/core/CustomScript");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class RevengeEffectArgs {
    constructor(baseDamage) {
        this.baseDamage = baseDamage;
        this.__type = EffectType_1.EffectType.Revenge;
        this.__typeName = "Revenge";
        this.name = "Revenge";
        this.harmful = false;
    }
}
exports.RevengeEffectArgs = RevengeEffectArgs;
let RevengeEffectHandler = class RevengeEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            baseDamage: state.args.baseDamage
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, new CustomScript_1.CustomScriptEventHandlerArgs("Ability_Revenge_OnAttack", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
RevengeEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Revenge)
], RevengeEffectHandler);
exports.RevengeEffectHandler = RevengeEffectHandler;
